import { render, staticRenderFns } from "./PatrolStatusPieChart.vue?vue&type=template&id=80050410&scoped=true"
import script from "./PatrolStatusPieChart.vue?vue&type=script&lang=js"
export * from "./PatrolStatusPieChart.vue?vue&type=script&lang=js"
import style0 from "./PatrolStatusPieChart.vue?vue&type=style&index=0&id=80050410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80050410",
  null
  
)

export default component.exports